import { PlusCircleIcon } from '@mm/icons';
import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import { Dispatch } from 'redux';
import { DropdownMenuItem } from '../../../../../common/components/DropdownMenu/DropdownMenuItem';
import { OnClickElsewhere } from '../../../../../common/components/OnClickElsewhere/OnClickElsewhere';
import modalActions from '@mm/state/modules/modalsState/actions';
import { StoreState } from '@mm/state/store-interfaces';
import './ExtraActionsButton.pcss';
import './MessageSender.pcss';
import { DialoguePickerModalProps } from '@mm/state/modules/modalsState/props';

const useExtraActionsButton = ({
  onDialogueSelected,
}: DialoguePickerModalProps) => {
  const dispatch: Dispatch<StoreState> = useDispatch();
  const [isAddMenuOpen, setIsAddMenuOpen] = useState(false);
  const openDialoguePicker = () =>
    dispatch(
      modalActions.openDialoguePickerModal({
        onDialogueSelected,
      }),
    );

  const toggleAddMenuOpen = () => setIsAddMenuOpen(!isAddMenuOpen);

  const ADD_MENU_ITEMS = [
    {
      icon: '',
      name: 'Launch Dialogue',
      onClick: (_: any) => openDialoguePicker(),
    },
  ];
  return {
    isAddMenuOpen,
    toggleAddMenuOpen,
    ADD_MENU_ITEMS,
  };
};

export const ExtraActionsButton = (props: DialoguePickerModalProps) => {
  const { isAddMenuOpen, toggleAddMenuOpen, ADD_MENU_ITEMS } =
    useExtraActionsButton(props);
  const { buttonClassName } = props;

  return (
    <div className={buttonClassName} onClick={toggleAddMenuOpen}>
      {isAddMenuOpen && (
        <OnClickElsewhere handleClick={toggleAddMenuOpen}>
          <div className="extra-actions-button--dropdown-menu__items-container">
            {ADD_MENU_ITEMS.map((i, idx) => (
              <DropdownMenuItem
                key={idx}
                icon={i.icon}
                name={i.name}
                onClick={e => {
                  i.onClick(e);
                  toggleAddMenuOpen();
                }}
              />
            ))}
          </div>
          <div className="extra-actions-button--dropdown-items-container__arrow2" />
        </OnClickElsewhere>
      )}
      <PlusCircleIcon color="#938BB7" />
    </div>
  );
};
